import React from 'react';
import './App.scss';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import CHome from './components/App/cilpron/Home/CHome';
import LoginPage from './components/authentication/Login/LoginPage';
import Dashboard from './components/App/dashboard/Dashboard';
import { PrivateRoute } from './components/authentication/Routes/PrivateRoute';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <FluentProvider theme={webLightTheme}>
        <Router>
          <Routes>
            <Route path="/*" element={<CHome />} />
            <Route path="/auth/login" element={<LoginPage />} />
            <Route
              path="/dashboard/*"
              element={
                <PrivateRoute unauthenticatedFallback={<LoginPage />}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </FluentProvider>
    </Provider>
  );
};

export default App;